export default (router) => {
  return (error) => {
    if (error.response && error.response.status === 503) {
      router.push({name: '503'});
    }
    return Promise.reject(error);
  }
}
